/*
 * @Author: hai.zhang
 * @LastEditors: Please set LastEditors
 * @Date: 2019-08-19 10:12:38
 * @LastEditTime: 2021-03-16 19:53:34
 */
export default {
  main: [
    // 购物车
    {
      name: 'cart',
      path: '/cart',
      component: () => import(/* webpackChunkName: "cart" */'../routes/cart/index/index.vue'),
      meta: {
        title: {
          'zh-CN': '购物车',
          en: '购物车_en',
          jp: '购物车_jp'
        },
        spmB: 'b16'
      }
    },
    // 再来一单
    {
      name: 'buy-again',
      path: '/buy-again',
      component: () => import(/* webpackChunkName: "buy-again" */'../routes/cart/buy-again/index.vue'),
      meta: {
        title: {
          'zh-CN': '再来一单',
          en: '再来一单_en',
          jp: '再来一单_jp'
        },
        spmB: 'b17',
        i18nCode: 'cart'
      }
    }
  ],
  fluid: [
  ]
}
